import { gql } from '@apollo/client'

export const GET_NEXT_STATUS_BY_CURRENT_STATUS = gql`
  query GetNextStatusByName($name: String) {
    getNextStatusByName(name: $name) {
      id
      name
      type
    }
  }
`

export const GET_ALL_STATUS_GROUP_BY_TYPE = gql`
  query GetAllStatusGroupByType($searchQuery: String) {
    getAllStatusGroupByType(searchQuery: $searchQuery) {
      type
      count_status
    }
  }
`

export const GET_ALL_STATUS = gql`
  query GetAllCatalogStatus(
    $type: String
    $searchQuery: String
    $limit: Int
    $offset: Int
    $ids: [Int]
    $getOwnStatus: Boolean
  ) {
    getAllCatalogStatus(
      type: $type
      searchQuery: $searchQuery
      limit: $limit
      offset: $offset
      ids: $ids
      getOwnStatus: $getOwnStatus
    ) {
      count
      rows {
        id
        name
        type
        description
        progress
        color
        order
      }
      count
    }
  }
`

export const GET_ONE_STATUS = gql`
  query GetOneCatalogStatus($id: Int!) {
    getOneCatalogStatus(id: $id) {
      id
      name
      type
      description
      progress
      color
      order
    }
  }
`

export const CREATE_STATUS = gql`
  mutation CreateStatus($input: StatusInput!) {
    createStatus(input: $input) {
      id
      name
      type
      description
      progress
      color
      order
    }
  }
`

export const UPDATE_STATUS = gql`
  mutation UpdateStatus($id: Int!, $input: StatusInput!) {
    updateStatus(id: $id, input: $input)
  }
`

export const DELETE_STATUS = gql`
  mutation DeleteStatus($id: Int!) {
    deleteStatus(id: $id)
  }
`

export const GET_ALL_STATUS_BY_TYPE = gql`
  mutation GetAllStatusByType($type: String!) {
    getAllStatusByType(type: $type) {
      id
      name
      type
      description
      progress
      color
      order
    }
  }
`

export const SAVE_ORDER_STATUS = gql`
  mutation SaveOrderStatus($input: [OrderStatusInput!]!) {
    saveOrderStatus(input: $input)
  }
`
